import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { HttpService } from '../../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class CadastrarFornecedorService {

  constructor(private http: HttpService, private httpService:HttpService) { }
  
  
  saveRegisterSupplier(data:any, successHandle:Function, errorHandle:Function){
    return this.httpService.doPost('/enterprise/providerRegister',data,successHandle, errorHandle);
    }

  address(path:any, data: any, successHandle: Function, errorHandle: Function) {

      return this.http.doGet('/person/address/'+path, data, successHandle, errorHandle);
  
    }

}

